import { render } from "./ModalCopyRole.vue?vue&type=template&id=0384e59e"
import script from "./ModalCopyRole.vue?vue&type=script&lang=js"
export * from "./ModalCopyRole.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__